import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { RULES } from 'src/lib/validation';
import useValidatedForm from 'src/hooks/useValidatedForm';
import { PopupWithInputField } from 'src/components/PopupWithInputField';

export const ProjectSettingsPopup = ({ open, data, onConfirm, onCancel }) => {
  const [disabled, setDisabled] = useState(false);
  const { name, isDocument, isDisplayedBeforeGoBack } = data;
  const {
    fields,
    errors,
    validate,
    update: updateForm,
  } = useValidatedForm({
    initialFields: { name },
    rules: { name: { [RULES.required]: true } },
  });

  const handleSubmit = useCallback(async () => {
    if (!validate()) {
      return;
    }

    try {
      setDisabled(true);
      await onConfirm({
        name: fields.name,
      });
    } finally {
      setDisabled(false);
    }
  }, [fields, validate, onConfirm]);

  const handleCancel = useCallback(async () => {
    if (!onCancel) {
      return;
    }

    // We may call "delete project" on "cancel" callback, hence async handling
    try {
      setDisabled(true);
      await onCancel();
    } finally {
      setDisabled(false);
    }
  }, [onCancel]);

  return (
    <PopupWithInputField
      cancelText={isDisplayedBeforeGoBack ? 'Just leave' : 'Cancel'}
      dataTestId="ProjectNamePopup"
      error={errors.name}
      onCancel={handleCancel}
      onChange={(e) => updateForm('name', e.target.value)}
      onSubmit={handleSubmit}
      open={open}
      submitText={isDisplayedBeforeGoBack ? 'Save and exit' : 'Save'}
      title={`Name your ${isDocument ? ' document' : ' project'}`}
      value={fields.name}
      disabled={disabled}
      isCloseHidden={true}
    />
  );
};

ProjectSettingsPopup.propTypes = {
  classes: PropTypes.shape({}),

  open: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string,
    isDocument: PropTypes.bool,
    isDisplayedBeforeGoBack: PropTypes.bool,
  }),
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ProjectSettingsPopup.defaultProps = {
  classes: null,
  data: null,
};
